import { load } from 'cheerio'
import type { Cheerio } from 'cheerio'
import type { AnyNode, Text } from 'domhandler'

const isNonEmptyTextNode = (node: AnyNode): node is Text => {
  return node.type === 'text' && Boolean((node as Text).data?.trim())
}

export const findDeepestTextElement = (
  element: Cheerio<AnyNode> | AnyNode,
): Cheerio<AnyNode> | null => {
  // Convert to Cheerio if it's a raw DOM node
  const $ = load('')
  const cheerioElement = 'length' in element ? element : $(element)

  const hasDirectTextContent = cheerioElement
    .contents()
    .toArray()
    .some(isNonEmptyTextNode)

  if (hasDirectTextContent) {
    return cheerioElement
  }

  let deepestElementWithText: Cheerio<AnyNode> | null = null

  const children = cheerioElement.children().toArray()
  for (const childElement of children) {
    const candidateElement = findDeepestTextElement(childElement)

    if (candidateElement?.length) {
      deepestElementWithText = candidateElement
    }
  }

  return deepestElementWithText
}
